import React, { ReactNode } from 'react';
import { Button } from '../../atoms/Button';
import { useCustomerInfo } from '../../../hooks/useCustomerInfo';
import { useTranslations } from '../../../hooks/useTranslations';
import styles from './FlowFooter.module.scss';

interface FlowFooterProps {
  onBack?: () => void;
  onNext?: () => void;
  onSaveAndNext?: () => void;
  isBackVisible?: boolean;
  isNextVisible?: boolean;
  isNextDisabled?: boolean;
  isSaveAndNextEnabled?: boolean;
  backText?: string;
  nextText?: string;
  saveAndNextText?: string;
  children?: ReactNode;
}

export const FlowFooter: React.FC<FlowFooterProps> = ({
  onBack,
  onNext,
  onSaveAndNext,
  isBackVisible = true,
  isNextVisible = true,
  isNextDisabled = false,
  isSaveAndNextEnabled = false,
  backText,
  nextText,
  saveAndNextText,
}) => {
  const customerInfo = useCustomerInfo();
  const t = useTranslations();

  // デフォルトテキストを翻訳対応
  const defaultBackText = backText || t.flowFooter_back;
  const defaultNextText = nextText || t.flowFooter_next;
  const defaultSaveAndNextText = saveAndNextText || t.flowFooter_saveAndNext;

  const shouldShowSaveAndNext = isSaveAndNextEnabled && customerInfo.canOrder;

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {isBackVisible && (
          <button onClick={onBack} className={styles.backButton}>
            <svg
            className={styles.arrowLeft}
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 24 24"
            >
              <g id="arrow_right_alt">
                <mask
                  height="24"
                  id="mask0_7171_26588"
                  maskUnits="userSpaceOnUse"
                  style={{ maskType: 'alpha' }}
                  width="24"
                  x="0"
                  y="0"
                >
                  <rect fill="#111111" height="24" id="Bounding box" width="24" />
                </mask>
                <g mask="url(#mask0_7171_26588)">
                  <path
                    d="M13.8462 17.6537L12.7923 16.5692L16.6115 12.75H4.5V11.25H16.6115L12.7923 7.43075L13.8462 6.34625L19.5 12L13.8462 17.6537Z"
                    fill="#111111"
                    id="arrow_right_alt_2"
                  />
                </g>
              </g>
            </svg>
            {defaultBackText}
          </button>
        )}
        
        {isNextVisible && (
          <Button 
            variant="default" 
            onClick={onNext} 
            disabled={isNextDisabled} 
            hasArrow 
            className={styles.nextButton}
          >
            <span>{defaultNextText}</span>
          </Button>
        )}
        
        {shouldShowSaveAndNext && (
          <Button 
            variant="default" 
            onClick={onSaveAndNext} 
            disabled={isNextDisabled}
            hasArrow 
            className={styles.saveAndNextButton}
          >
            <span>{defaultSaveAndNextText}</span>
          </Button>
        )}
      </div>
    </footer>
  );
}; 